import React from 'react';
import { requestReceivedCopy } from '../lib/requestReceivedCopy';

// The three-line "we received your request" block (owner, 2026-10-03). Used on
// every request confirmation screen; see src/lib/requestReceivedCopy.js.
// `showTitle={false}` when the screen already renders the title itself.
export default function RequestReceived({ lang = 'ar', showTitle = true, style }) {
  const isAr = lang === 'ar';
  const c = requestReceivedCopy(lang);
  const font = isAr ? 'var(--font-ar)' : 'var(--font-sans)';
  return (
    <div dir={isAr ? 'rtl' : 'ltr'} style={{ fontFamily: font, ...style }}>
      {showTitle && (
        <p style={{ margin: '0 0 6px', fontSize: 16, fontWeight: 700, color: 'var(--text-primary)' }}>{c.title}</p>
      )}
      <p style={{ margin: '0 0 6px', fontSize: 13.5, lineHeight: 1.8, color: 'var(--text-secondary)' }}>{c.body}</p>
      <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.8, color: 'var(--text-primary)' }}>{c.notify}</p>
    </div>
  );
}
